import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PerformerAchievementResponse, ContestMainProgressResponse } from 'domains/Achievements/Achievements.types';
import { AchievementsState } from './Achievements.types';

export const initialState: AchievementsState = {
    me: {
        data: {
            globalRank: 0,
            level: 0,
            points: 0,
            missingPointsToTop: null,
        },
        requestStatus: 'initial',
    },
    mainProgress: { data: { conversionScore: undefined, trafficScore: undefined }, requestStatus: 'initial' },
};

const achievementsSlice = createSlice({
    name: 'achievements',
    initialState,
    reducers: {
        fetchMyAchievementsStarted: (state) => {
            state.me.requestStatus = 'pending';
        },
        fetchMyAchievementsSucceeded: (state, action: PayloadAction<PerformerAchievementResponse>) => {
            state.me.requestStatus = 'resolved';
            state.me.data = action.payload.data;
        },
        fetchMyAchievementsFailed: (state) => {
            state.me.requestStatus = 'rejected';
        },
        fetchMainProgressStarted: (state) => {
            state.mainProgress.requestStatus = 'pending';
        },
        fetchMainProgressSucceeded: (state, action: PayloadAction<{ data: ContestMainProgressResponse }>) => {
            const { data } = action.payload;

            state.mainProgress.requestStatus = 'resolved';
            state.mainProgress.data = data;
        },
        fetchMainProgressFailed: (state) => {
            state.mainProgress.requestStatus = 'rejected';
        },
    },
});

export const {
    fetchMyAchievementsStarted,
    fetchMyAchievementsSucceeded,
    fetchMyAchievementsFailed,
    fetchMainProgressStarted,
    fetchMainProgressSucceeded,
    fetchMainProgressFailed,
} = achievementsSlice.actions;

export default achievementsSlice.reducer;
